import { JobBlock, JobBlockDisplayType } from '@/lib/types';
import { useGlobalContext } from '@/hooks/use-global-context';

import JobBlocks from '@/features/job-blocks';
import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';
import jobBlocksTransformer from '@/hygraph/transformers/job-blocks.transformer';

export default function JobBlocksRenderer(props: JobBlock) {
  const { specialty, specialtyPageStaticData } = useSpecialtyPageContext();
  const { pageStaticData } = useGlobalContext();

  const jobs = specialty
    ? specialtyPageStaticData?.jobBlocks[props.id]
    : pageStaticData?.jobBlocks?.[props.id];

  const jobBlockDisplayType = specialty
    ? JobBlockDisplayType.CardCarousel
    : props.jobBlockDisplayType;

  return (
    <JobBlocks
      {...jobBlocksTransformer(
        {
          ...props,
          jobBlockDisplayType,
        },
        jobs
      )}
    />
  );
}
